export const apiPathName = process.env.NEXT_PUBLIC_API_BASE_URL;

const getApiUrl = (src: string) => {
    if (src == '' || !src) return null
    return `${apiPathName}${src}`;
}

export default getApiUrl
